export const getLastElement = <T>(array: Array<T>): T | undefined => {
	if (array.length) return array[array.length - 1];

	return undefined;
};
